import { ApiDashboardItem } from '../api-types/dashboard.api';
import { DashboardItem } from '../app-types/dashboard.app';
import { transformApiActiveAssignmentTsoAppActiveAssignments } from './assignment.transform';

export const transformApiDashboardItemToAppDashboardItem = (input: ApiDashboardItem) => {
	const output: DashboardItem = {
		id: input.id,
		objectId: input.objectId,
		fullName: input.fullName,
		personType: input.personType,
		serviceName: input.serviceName,
		ifdName: input.ifdName,
		activeAssignments: transformApiActiveAssignmentTsoAppActiveAssignments(input.activeAssignments),
		activeAssignmentForTheUserCount: input.activeAssignmentForTheUserCount,
	};
	return output;
};

export const transformApiDashboardItemsToAppDashboardItems = (input: ApiDashboardItem[]): DashboardItem[] => {
	return input.map(transformApiDashboardItemToAppDashboardItem);
};
